// @flow
import type {SagaIterator} from 'redux-saga';
import {pushDataLayer} from '@optimaxdev/analytics/mobile';

import type {SimpleProductType} from 'constants/flow/flowTypesProduct';
import type {ActionType} from 'constants/flow/flowTypes';
import {ANALYTICS} from 'constants/actions';

import {call, select, takeEvery} from 'redux-saga/effects';
import {productToEECProduct} from 'libs/EEC/convertData/productToEECProduct';
import {getCategory} from 'selectors/category/category';

/**
 * This event is supposed to send products which have been shown for customers.
 *
 * @param {Array<SimpleProductType>} products - Category active simples.
 */
export function* showSimpleProducts(products: Array<SimpleProductType>): SagaIterator {
    const {title} = yield select(getCategory);
    const impressions = yield call(
        productToEECProduct,
        products,
        {
            category: title,
            index: 1,
        },
        {
            list: window.location.pathname,
        },
    );
    yield call(pushDataLayer, {
        event: 'EEC_product_impression',
        ecommerce: {
            currencyCode: 'USD',
            impressions,
        },
    });
}

/**
 * Send shown items on change active color.
 *
 * @param {ActionType<void, {product: Array<SimpleProductType>}>} action - Change color action.
 */
export function* onItemColorChange(
    action: ActionType<void, {product: Array<SimpleProductType>}>,
): SagaIterator {
    if (action.meta) {
        const {product} = action.meta;
        yield call(showSimpleProducts, product);
    }
}

/**
 * Category E-commerce saga.
 */
export default function* categoryEcommerce(): SagaIterator {
    yield takeEvery(ANALYTICS.CATEGORY_COLOR_CHANGE, onItemColorChange);
}
